import { ExternalLinkIcon, InfoIcon } from "lucide-react";

import { FormType } from "@/integrations";

export default function InformationForm({
  field,
}: {
  field: Extract<FormType, { type: "information" }>;
}) {
  const { title, description, link } = field;

  return (
    <div className="flex gap-3 rounded-md border border-gray-300 bg-gray-50 p-4 dark:border-gray-600 dark:bg-gray-700">
      <InfoIcon className="size-4 shrink-0 text-gray-500 dark:text-gray-400" />
      <div className="space-y-1">
        <p className="text-sm font-medium">{title}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
        {!!link && (
          <a
            href={link.url}
            target="_blank"
            rel="noreferrer"
            className="flex flex-row items-center justify-start gap-1 text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"
          >
            {link.label} <ExternalLinkIcon className="inline size-3" />
          </a>
        )}
      </div>
    </div>
  );
}
